import React from "react";
import "./Hero.css";
import heroImg from "../assets/hero-portrait.png"; // Replace with your image path

function Hero() {
  // Helper function for smooth scrolling to section IDs
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero" id="home">
      {/* Top Main Section */}
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-left">
          <p className="subtitle">— AESTHETICS & SKINCARE CLINIC</p>

          <h1 className="title">
            Enhance your <i>natural</i> beauty
          </h1>

          <p className="description">
            Premium treatments, affordable prices and real, natural-looking results.
            Every plan is designed around your skin, your face and your goals —
            delivered by experienced practitioners in Milton Keynes.
          </p>

          <div className="hero-buttons">
            <button
              className="btn-primary"
              onClick={() => scrollToSection("contact")}
            >
              BOOK FREE CONSULTATION
            </button>
            <button
              className="btn-secondary"
              onClick={() => scrollToSection("treatments")}
            >
              EXPLORE SERVICES
            </button>
          </div>

          <div className="hero-trust">
            <span>★★★★★ Loved by hundreds of clients</span>
            <span>📍 Milton Keynes, UK</span>
          </div>
        </div>

        {/* Right Image Container */}
        <div className="hero-right">
          <div className="image-wrapper">
            <img src={heroImg} alt="Facial treatment" />

            {/* Floating Offer Card */}
            <div className="offer-card">
              <span className="offer-tag">FIRST VISIT GIFT</span>
              <p className="offer-text">10% off your first treatment</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Stats Section */}
      <div className="hero-stats">
        <div className="stat-item">
          <h2>1,400+</h2>
          <p>TREATMENTS DELIVERED</p>
        </div>
        <div className="stat-item">
          <h2>6</h2>
          <p>TREATMENT CATEGORIES</p>
        </div>
        <div className="stat-item">
          <h2>30+</h2>
          <p>BESPOKE PROCEDURES</p>
        </div>
        <div className="stat-item">
          <h2>5.0</h2>
          <p>AVERAGE CLIENT RATING</p>
        </div>
      </div>
    </section>
  );
}

export default Hero;